export default __webpack_public_path__ + "static/media/login.0a70b23b.jpg";